module.exports = __webpack_public_path__ + "static/media/Venonat_gaussian2.53db8371.png";